<div id="el2">
  <span class="mat-title title">{{ title }}</span>
  <button mat-icon-button disableRipple (click)="dismiss()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<p class="mat-subheading-2 message">{{ message }}</p>
